import { Suspense, useEffect } from "react";
import { Navigate, Outlet } from "react-router";

import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/uz";
import "dayjs/locale/uz-latn";
import { useTranslation } from "react-i18next";
import Layout from "../layouts";
import { useAuthStore } from "../store/useAuthStore";

function Root() {
  const { isAuth } = useAuthStore();
  const { i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language === "oz" ? "uz-latn" : i18n.language);
  }, [i18n.language]);

  // if (!isAuth) {
  //   return <Navigate to="/auth/sign-in" />;
  // }

  return (
    <Suspense>
      <Layout>
        <Outlet />
      </Layout>
    </Suspense>
  );
}

export default Root;
